import { Constant } from "app/shared/constant/constant";
import i18n from "app/shared/language/i18n";
import { CARDITEM } from "app/shared/services/services-model.type";

interface StatusCardItem {
  KEY: string;
  NAME: string;
  TEXT: string;
  VALID: string;
}

export const LIST_STATUS_CARD = [
  { KEY: "0", NAME: "VALID CARD", TEXT: i18n.t("CARD_TRANG_THAI_HOAT_DONG"), VALID: i18n.t("CARD_TRANG_THAI_HOAT_DONG") },
  { KEY: "1", NAME: "CALL ISSUER", TEXT: i18n.t("CARD_TRANG_THAI_CHUA_KICH_HOAT"), VALID: i18n.t("CARD_TRANG_THAI_CHUA_KICH_HOAT_VALID") },
  { KEY: "2", NAME: "WARM CARD", TEXT: i18n.t("CARD_TRANG_THAI_KHOA"), VALID: i18n.t("CARD_TRANG_THAI_KHOA_VALID") },
  { KEY: "3", NAME: "DO NOT HONOR", TEXT: i18n.t("CARD_TRANG_THAI_KHOA"), VALID: i18n.t("CARD_TRANG_THAI_KHOA_VALID") },
  { KEY: "5", NAME: "NOT PERMITTED", TEXT: i18n.t("CARD_TRANG_THAI_KHOA"), VALID: i18n.t("CARD_TRANG_THAI_KHOA_VALID") },
  { KEY: "6", NAME: "LOST CARD CAPTURE", TEXT: i18n.t("CARD_TRANG_THAI_KHOA"), VALID: i18n.t("CARD_TRANG_THAI_KHOA_VALID") },
  { KEY: "7", NAME: "STOLEN CARD", TEXT: i18n.t("CARD_TRANG_THAI_KHOA"), VALID: i18n.t("CARD_TRANG_THAI_KHOA_VALID") },
  { KEY: "11", NAME: "CALL ACQUIRER ACTIVATED", TEXT: i18n.t("CARD_TRANG_THAI_KHOA"), VALID: i18n.t("CARD_TRANG_THAI_KHOA_VALID") },
  { KEY: "12", NAME: "CARD IS NOT ACTIVATED", TEXT: i18n.t("CARD_TRANG_THAI_KHOA"), VALID: i18n.t("CARD_TRANG_THAI_KHOA_VALID") },
  {
    KEY: "14",
    NAME: "FORCED PIN CHANGE",
    TEXT: i18n.t("CARD_TRANG_THAI_CHUA_DOI_PIN"),
    VALID: i18n.t("CARD_TRANG_THAI_CHUA_DOI_PIN_VALID"),
  },
  { KEY: "15", NAME: "CREDIT DEBT", TEXT: i18n.t("CARD_TRANG_THAI_KHOA"), VALID: i18n.t("CARD_TRANG_THAI_KHOA_VALID") },
  { KEY: "19", NAME: "FRAUD PREVENTION", TEXT: i18n.t("CARD_TRANG_THAI_KHOA"), VALID: i18n.t("CARD_TRANG_THAI_KHOA_VALID") },
  {
    KEY: "20",
    NAME: "TEMPORARY BLOCKED BY CLIENT",
    TEXT: i18n.t("CARD_TRANG_THAI_TAM_KHOA"),
    VALID: i18n.t("CARD_TRANG_THAI_TAM_KHOA_VALID"),
  },
];

export const ArrayCreditShow: Array<string> = ["0", "20", "2", "15", "6", "19", "12", "11", "3", "7", "5"]; // Các trạng thái thẻ tín dụng hiển thị LS giao dịch, Sao kê, Thanh toán thẻ
export const ArrayDebitShowHistory: Array<string> = ["0", "20", "6", "19", "12", "3", "7", "5"]; // Các trạng thái thẻ Ghi nợ hiển thị LS giao dịch

export const CLASS_PLATINUM = "511962";

export const LIST_CARD_PROTOTYPE = [
  { KEY: "51196255", IMAGE: "credit_platinum_cashback" }, // Thẻ tín dụng Platinum Cashback
  { KEY: "51196222", IMAGE: "credit_platinum_shopping" }, // Thẻ tín dụng Platinum Shopping
  { KEY: "51196299", IMAGE: "credit_platinum_travel" }, // Thẻ tín dụng Platinum Travel
  { KEY: "51196288", IMAGE: "credit_platinum_old" }, // Thẻ tín dụng Platinum Mastercard cũ

  { KEY: "53874255", IMAGE: "credit_standard_cashback" }, // "Thẻ tín dụng Standard Cashback"
  { KEY: "53874222", IMAGE: "credit_standard_shopping" }, // Thẻ tín dụng Standard Shopping
  { KEY: "53874288", IMAGE: "credit_mastercard_class" }, // Thẻ tín dụng Mastercard Class
  { KEY: "54255388", IMAGE: "credit_mastercard_gold" }, // Thẻ tín dụng Mastercard Gold

  { KEY: "51745461", IMAGE: "debit_international" }, // Thẻ ghi nợ quốc tế
  { KEY: "97041256", IMAGE: "debit_local" }, // "Thẻ ghi nợ nội địa"
];

export const CARD_TYPE_REGISTER = [
  { value: "CR", label: "Thẻ tín dụng PVcomBank", other: "0" }, // Thẻ tín dụng
  { value: "DB", label: "Thẻ ghi nợ nội địa PVcomBank", other: "0" }, // Thẻ ghi nợ
];

export const getHotStatus = (status?: string) => {
  const statusFilter: Array<StatusCardItem> = LIST_STATUS_CARD.filter((_item) => {
    return _item.KEY === status;
  });
  if (statusFilter.length) return statusFilter[0].TEXT;
  return "";
};

export const getCardValidStatus = (status?: string) => {
  const statusFilter: Array<StatusCardItem> = LIST_STATUS_CARD.filter((_item) => {
    return _item.KEY === status;
  });
  if (statusFilter.length) return statusFilter[0].VALID;
  return "";
};

export const getTitleCard = (cardType?: string) => {
  switch (cardType) {
    case Constant.CARD.CARD_TYPE.CREDIT:
      return i18n.t("CARD_THE_TIN_DUNG");
    case Constant.CARD.CARD_TYPE.DEBIT:
      return i18n.t("CARD_THE_GHI_NO_NOI_DIA");
    case Constant.CARD.CARD_TYPE.DEBIT_MASTER:
      return i18n.t("CARD_THE_GHI_NO_QUOC_TE");
    case Constant.CARD.CARD_TYPE.PREPAID:
      return i18n.t("CARD_THE_TRA_TRUOC");
    default:
      return "";
  }
};

export const getCardNumber = (value?: string) => {
  if (!value) {
    return "";
  }
  var string = value.toString();
  const maxLength = 16;

  if (string.length > maxLength) string = string.slice(0, maxLength);

  while (string.length < maxLength) {
    string += "*";
  }
  return string;
};

export const getFourNumberStart = (value?: string) => {
  if (!value) {
    return "";
  }
  var fourNumber = value.toString();
  fourNumber = "" + fourNumber.slice(0, 4);
  return fourNumber;
};

export const getMemberSince = (value?: string) => {
  if (!value) {
    return "**/**";
  }
  var memberSince = value.toString();
  const expiryMaxLength = 6;
  if (memberSince.match(/\//)) memberSince = memberSince.replace("/", "");

  if (!memberSince.match(/^[0-9]*$/)) return "**/**";
  while (memberSince.length < 4) {
    memberSince += ".";
  }
  memberSince = memberSince.slice(0, 2) + "/" + memberSince.slice(2, expiryMaxLength);
  return memberSince;
};

export const getExpiry = (value?: string) => {
  if (!value) {
    return "**/**";
  }
  var expiry = value.toString();

  const expiryMaxLength = 6;

  if (expiry.match(/\//)) expiry = expiry.replace("/", "");

  if (!expiry.match(/^[0-9]*$/)) return "**/**";

  while (expiry.length < 4) {
    expiry += "*";
  }
  expiry = expiry.slice(0, 2) + "/" + expiry.slice(2, expiryMaxLength);
  return expiry;
};

export const handlerCardPrimary = (data?: CARDITEM[]) => {
  let listNew: CARDITEM[] = [];
  if (data?.length) {
    const cardPrimary = data.filter((item) => {
      return item.primaryCard === true;
    });
    if (cardPrimary.length) {
      listNew = listNew.concat(cardPrimary);
    }
    const cardNotPrimary = data.filter((item) => {
      return item.primaryCard === false;
    });
    if (cardNotPrimary.length) {
      listNew = listNew.concat(cardNotPrimary);
    }
  }
  return listNew;
};

export const handlerMapListCard = (data?: CARDITEM[]) => {
  let listNew: CARDITEM[] = [];
  if (data?.length) {
    const cardCredit = data.filter((item) => {
      return item.cardType === Constant.CARD.CARD_TYPE.CREDIT;
    });
    if (cardCredit.length) {
      const credit_platinum_cashback = cardCredit.filter((item) => {
        return item.cardClass === LIST_CARD_PROTOTYPE[0].KEY;
      });
      if (credit_platinum_cashback.length) listNew = listNew.concat(handlerCardPrimary(credit_platinum_cashback));

      const credit_platinum_shopping = cardCredit.filter((item) => {
        return item.cardClass === LIST_CARD_PROTOTYPE[1].KEY;
      });

      if (credit_platinum_shopping.length) listNew = listNew.concat(handlerCardPrimary(credit_platinum_shopping));

      const credit_platinum_travel = cardCredit.filter((item) => {
        return item.cardClass === LIST_CARD_PROTOTYPE[2].KEY;
      });

      if (credit_platinum_travel.length) listNew = listNew.concat(handlerCardPrimary(credit_platinum_travel));

      const credit_platinum_old = cardCredit.filter((item) => {
        return item.cardClass === LIST_CARD_PROTOTYPE[3].KEY;
      });

      if (credit_platinum_old.length) listNew = listNew.concat(handlerCardPrimary(credit_platinum_old));

      const credit_standard_cashback = cardCredit.filter((item) => {
        return item.cardClass === LIST_CARD_PROTOTYPE[4].KEY;
      });

      if (credit_standard_cashback.length) listNew = listNew.concat(handlerCardPrimary(credit_standard_cashback));

      const credit_standard_shopping = cardCredit.filter((item) => {
        return item.cardClass === LIST_CARD_PROTOTYPE[5].KEY;
      });

      if (credit_standard_shopping.length) listNew = listNew.concat(handlerCardPrimary(credit_standard_shopping));

      const credit_mastercard_class = cardCredit.filter((item) => {
        return item.cardClass === LIST_CARD_PROTOTYPE[6].KEY;
      });

      if (credit_mastercard_class.length) listNew = listNew.concat(handlerCardPrimary(credit_mastercard_class));

      const credit_mastercard_gold = cardCredit.filter((item) => {
        return item.cardClass === LIST_CARD_PROTOTYPE[7].KEY;
      });

      if (credit_mastercard_gold.length) listNew = listNew.concat(handlerCardPrimary(credit_mastercard_gold));
    }
    const cardDebitMaster = data.filter((item) => {
      return item.cardType === Constant.CARD.CARD_TYPE.DEBIT_MASTER;
    });
    if (cardDebitMaster.length) listNew = listNew.concat(handlerCardPrimary(cardDebitMaster));
    const cardDebit = data.filter((item) => {
      return item.cardType === Constant.CARD.CARD_TYPE.DEBIT;
    });
    if (cardDebit.length) listNew = listNew.concat(handlerCardPrimary(cardDebit));
  }
  return listNew;
};
